<template>
  <div
    class="grid shrink-0 place-items-center overflow-hidden rounded-[var(--radius-md)] bg-secondary text-primary"
    :class="sizes[size]"
  >
    <img
      v-if="src"
      :src="src"
      :alt="alt ?? ''"
      class="h-full w-full object-contain p-1.5"
    />
    <span v-else>{{ glyph }}</span>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  glyph: string
  src?: string | null
  alt?: string
  size?: 'xs' | 'sm' | 'md' | 'lg'
}>()

const sizes: Record<string, string> = {
  xs: 'h-9 w-9 text-sm',
  sm: 'h-10 w-10 text-lg',
  md: 'h-12 w-12 text-xl',
  lg: 'h-16 w-16 text-3xl',
}
</script>
